import React from 'react'

function Notfound() {
  return (
    <div>
      <div class="main-wrapper error-wrapper">
        <div class="error-box">
            <h1>404</h1>
            <h3><i class="fas fa-exclamation-triangle"></i> Oops! Page not found!</h3>
            <p>The page you requested was not found.</p>
            <a href="/" class="btn btn-primary go-home">Go to Home</a>
        </div>
    </div>
    </div>
  )
}

export default Notfound
